import React, { useEffect, useState, useContext } from 'react';
import helpers from '../../../services/helpers';
// import QRCode from 'react-qr-code';
import { QRCode } from 'react-qrcode-logo';
import images from '../../../services/images';

export default function GenerateQRPrintView (){
   
    // useEffect(() => {
    // }, []);

    function Cards(){
        let prefix = helpers.getURLParams('prefix');
        if(!prefix){
            prefix = `${window.location.origin}/product-units/qr/`;
        }
        const start = parseInt(helpers.getURLParams('start'), 10);
        const end = parseInt(helpers.getURLParams('end'), 10);
        const caption = helpers.getURLParams('caption');

        if (Number.isNaN(start) || Number.isNaN(end) || start > end) {
            return <div>Invalid range</div>;
        }

        const range = Array.from(
            { length: end - start + 1 },
            (_, i) => start + i
        );

        return (//#1789d0
            <div className="row">
            {range.map(num => (
                <div className="col-3 border p-4" key={num}>
                    <div
                        style={{
                            textAlign: 'center',
                            fontSize: '1.7rem',
                            marginBottom: '5px'
                        }}
                    >
                        <span style={{fontWeight: 'bold', color: '#1172b9'}}>Polar-Air</span> <span style={{fontWeight: 500, color: '#22a2e3'}}>Aircon</span>
                    </div>
                    <QRCode 
                        value={`${prefix}${num}`} 
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }} 
                        fgColor="#1172b9"
                        logoImage={images.polarair_icon}
                        ecLevel="H"                      // 1. ADD THIS: High error correction
                        //removeQrCodeBehindLogo={true}    // 2. UNCOMMENT THIS: Clears modules
                        //logoPadding={1}                  // 3. ADD THIS: Small buffer for scanning
                        qrStyle="dots"
                        logoWidth={70}
                        logoHeight={70}
                        quietZone={0}
                    />
                    {/* <h5 className='mt-2 mb-0 text-center'>{caption}</h5> */}
                    <div 
                        style={{
                            padding: '5px 7px', 
                            backgroundColor: '#22a2e3', 
                            color:'#fff', 
                            textAlign: 'center', 
                            fontSize: '.8rem',
                            fontWeight: 'bold',
                            borderRadius: '10px',
                            printColorAdjust: 'exact',
                            WebkitPrintColorAdjust: 'exact',
                            marginTop: '10px'
                        }}
                    >Scan to know unit history or report an issue</div>
                </div>
                
            ))}
            </div>
        );
    }

    return (
        <div className="invoice p-4 mb-3 rounded">
            <Cards />
        </div>
    )
}